export function planRoute(destination: string) {
  const url = new URL('https://www.google.com/maps/search/?api=1');
  url.searchParams.set('query', destination);
  window.open(url.toString(), '_blank');
}
